// RootLayout.jsx
import { Drawer, Button } from "antd";
import { MenuOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";
import Cookies from "js-cookie"; // ✅ Thêm để đọc token
import "./styles.scss";

const RootLayout = ({ header, menu, content }) => {
  const [isMobile, setIsMobile] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  const isLoggedIn = !!Cookies.get("access_token"); // ✅ Kiểm tra login

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 1025);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="root-container">

      {/* Sidebar - hidden on mobile if not open */}
      {menu && (!isMobile || (isMobile && menuOpen)) && (
        <div className={`root-left ${isMobile ? "mobile" : ""}`}>
          {menu}
        </div>
      )}

      {/* Main content */}
      <div
        className={`${menu ? "root-right" : "root-right-fill"
          } ${isMobile ? "mobile" : ""}`}
      >
        {/* Mobile menu button */}
        {isMobile && isLoggedIn && !menuOpen && (
          <Button
            type="text"
            icon={<MenuOutlined style={{ fontSize: "22px" }} />}
            onClick={() => setMenuOpen(true)}
            className="floating-menu-btn"
          />
        )}

        {/* Header */}
        {header}

        {/* Scrollable content */}
        <div className="root-scrollable-content">{content}</div>
      </div>

      {isMobile && isLoggedIn && (
        <Drawer
          title="メニュー"
          placement="left"
          onClose={() => setMenuOpen(false)}
          open={menuOpen}
          width={250}
          bodyStyle={{ padding: 0 }}
          className="mobile-menu-drawer"
        >
          {menu && menu.type
            ? <menu.type {...menu.props} isInDrawer={true} onCloseDrawer={() => setMenuOpen(false)} />
            : menu}
        </Drawer>
      )}
    </div>
  );
};

export default RootLayout;
